import React, { useState } from 'react';
import { object, array, func } from 'prop-types';
import UserPropType from '../../../../proptypes/UserPropType';

import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { getPhotoUrl } from '../../../../utils/photo_helper';
import { urlReformatPhotos } from '../../../../utils/lightbox_helpers';
import AddGreenIcon from '../../../../../assets/images/icons/add-green.svg';
import AllTrailsLogo from '../../../../../assets/images/icons/alltrails-gray-logo.svg';

import Lightbox from '../../../shared/Lightbox';
import PhotosTab from '../PhotosTab/PhotosTab';

import * as styles from './styles/styles.module.scss';

const PhotosSection = ({ currentUser, track, data, handlePhotosUpload, openTrailFormModal, messagingChannel }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxStartingIndex, setLightBoxStartingIndex] = useState(null);
  const [lightboxImages, setLightBoxImages] = useState([]);

  const addMapPhotoMarkers = photos => {
    messagingChannel.publish({
      topic: 'mapPhoto.add.toModel',
      data: photos
    });
  };
  const handlePhotoHover = mapPhotoId => {
    messagingChannel.publish({
      topic: 'photo.hover',
      data: mapPhotoId
    });
  };
  const handleUpload = photo => {
    const photos = photo.detail;
    if (handlePhotosUpload) handlePhotosUpload(photos);
    addMapPhotoMarkers(photos);
  };
  const handlePlaceholderClick = () => {
    if (currentUser && currentUser.id == track.user.id) {
      const url = `/api/alltrails/maps/${track.id}/photos?key=${ServerCommunicationUtil.apiKey}`;
      openTrailFormModal('photos', { url, onPhotosAdd: handleUpload });
    }
  };
  const handleMapPhotoClick = mapPhotoId => {
    let newIndex;
    const newLightBoxImages = data.map((item, index) => {
      if (mapPhotoId === item.photo.id) {
        newIndex = index;
      }

      return { ...item.photo, map_id: item.mapId };
    });

    setLightboxOpen(true);
    setLightBoxImages(newLightBoxImages);
    setLightBoxStartingIndex(newIndex);
  };
  const handleLightboxClose = () => {
    setLightboxOpen(false);
    setLightBoxStartingIndex(null);
    setLightBoxImages([]);
  };
  const getLightboxProps = () => {
    return {
      isOpen: lightboxOpen,
      images: urlReformatPhotos(lightboxImages),
      handleCloseRequest: handleLightboxClose,
      startingIndex: lightboxStartingIndex,
      mapId: track.id
    };
  };
  const sortedPhotos = data?.sort((a, b) => {
    return new Date(a?.photo?.metadata?.created) - new Date(b?.photo?.metadata?.created);
  });

  const renderPhotos = () => {
    let photos = [];
    if (sortedPhotos && sortedPhotos.length > 0) {
      photos = sortedPhotos.map((mapPhoto, i) => {
        const { id } = mapPhoto.photo;
        const hash = mapPhoto.photo.photoHash;
        const fallbackPhotoUrl = `/api/alltrails/photos/${id}/image?size=medium_square&key=${ServerCommunicationUtil.apiKey}`;
        let photoUrl;
        if (id && hash) {
          photoUrl = getPhotoUrl(id, hash, 'medium_square');
        } else {
          photoUrl = fallbackPhotoUrl;
        }
        let shouldFallback = true;
        const addFallbackSrc = ev => {
          if (shouldFallback) {
            ev.target.src = fallbackPhotoUrl;
            ev.target.onerror = null;
          }
          shouldFallback = false;
        };
        let hoverHandler = null;
        if (mapPhoto.location && mapPhoto.location.latitude != null && mapPhoto.location.longitude != null) {
          hoverHandler = handlePhotoHover(null, mapPhoto.id, id);
        }
        return (
          <li
            className={styles.uploadedPhoto}
            key={`photo-${mapPhoto.id}-${i}`}
            onClick={() => handleMapPhotoClick(id)}
            onMouseOver={hoverHandler}
            onFocus={hoverHandler}
          >
            <img className={styles.uploadedImg} alt={StringConstantsMixin.strings.ALLTRAILS} src={photoUrl} onError={addFallbackSrc} />
          </li>
        );
      });
    }
    if (currentUser && currentUser.id === track.user.id) {
      const addPhotosSquare = (
        <PhotosTab
          key="photos-add"
          srcIcon={AddGreenIcon}
          containerClass={styles.addPhotoSquare}
          innerClass={styles.addIcon}
          action={handlePlaceholderClick}
          altName={StringConstantsMixin.strings.CONTRIBUTE.UPLOAD_PHOTOS}
        />
      );
      photos.unshift(addPhotosSquare);
    }
    if (!photos.length) {
      return null;
    }
    if (photos.length < 3) {
      const numToAdd = 3 - photos.length;
      for (let i = 0; i < numToAdd; i++) {
        photos.push(
          <PhotosTab
            key={`photos-add-gray-${i}`}
            srcIcon={AllTrailsLogo}
            containerClass={styles.emptyPhotoContainer}
            action={handlePlaceholderClick}
            altName={StringConstantsMixin.strings.ALLTRAILS}
          />
        );
      }
    }

    return photos;
  };

  return (
    <>
      <ul key="photos" className={styles.photosTab}>
        {renderPhotos()}
      </ul>
      {lightboxOpen && <Lightbox key="lightbox" {...getLightboxProps()} />}
    </>
  );
};

PhotosSection.propTypes = {
  currentUser: UserPropType,
  track: object,
  data: array,
  handlePhotosUpload: func,
  openTrailFormModal: func
};

PhotosSection.defaultProps = {
  currentUser: {},
  track: {},
  data: [],
  handlePhotosUpload: () => {},
  openTrailFormModal: () => {}
};

export default PhotosSection;
